import { environment } from '../../../environments/environment';
export function billingSsoUrl(path='/invoices'):string {
  const configured=(environment as any).billingPortalUrl;
  const origin=configured || ((environment as any).envName==='production'?'https://billing.ringoffice.com':'https://billing-dev.ringoffice.com');
  const callback=new URL('/auth/sso/callback',origin);callback.searchParams.set('next',path);
  return '/sso?portal=billing-portal&return='+encodeURIComponent(callback.toString());
}
